import ReactTestUtils from 'react-dom/test-utils';
import { MessageBoxFunctionalLayoutTheme } from './MessageBoxFunctionalLayout.types';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

export type MessageBoxFunctionalLayoutDriver = ReturnType<
  typeof messageBoxFunctionalLayoutDriverFactory
>;

const messageBoxFunctionalLayoutDriverFactory = ({
  element,
}: {
  element: HTMLElement;
}) => {
  deprecationTestkitLog(
    'messageBoxFunctionalLayoutTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the MessageBoxFunctionalLayoutTestkit unidriver testkit instead.',
  );

  const confirmationButton = () =>
    element.querySelector<HTMLButtonElement>(
      '[data-hook="confirmation-button"]',
    );
  const cancellationButton = () =>
    element.querySelector<HTMLButtonElement>(
      '[data-hook="cancellation-button"]',
    );
  const headerCloseButton = () =>
    element.querySelector<HTMLButtonElement>(
      '[data-hook="header-close-button"]',
    );

  return {
    exists: () => !!element,
    element: () => element,
    getConfirmationButtonText: () => confirmationButton()!.textContent,
    isConfirmationButtonPrefixIconExists: () =>
      confirmationButton()!.innerHTML.indexOf('prefix') !== -1,
    isConfirmationButtonSuffixIconExists: () =>
      confirmationButton()!.innerHTML.indexOf('suffix') !== -1,
    clickOnConfirmationButton: () =>
      ReactTestUtils.Simulate.click(confirmationButton()!),
    getConfirmationButton: confirmationButton,
    getCancellationButton: cancellationButton,
    getHeaderCloseButton: headerCloseButton,
    getCancellationButtonText: () => cancellationButton()!.textContent,
    isCancellationButtonPrefixIconExists: () =>
      cancellationButton()!.innerHTML.indexOf('prefix') !== -1,
    isCancellationButtonSuffixIconExists: () =>
      cancellationButton()!.innerHTML.indexOf('suffix') !== -1,
    clickOnCancellationButton: () =>
      ReactTestUtils.Simulate.click(cancellationButton()!),
    clickOnHeaderCloseButton: () =>
      ReactTestUtils.Simulate.click(headerCloseButton()!),
    isThemeExist: (theme: MessageBoxFunctionalLayoutTheme) =>
      element.dataset.theme === theme,
    getFooter: () => element.querySelector('[data-hook="message-box-footer"]'),
    getTitle: () =>
      element.querySelector('[data-hook="header-layout-title"]')!.textContent,
    getChildBySelector: (selector: string) => element.querySelector(selector),
    isCancelEnable: () => !cancellationButton()!.disabled,
    isConfirmationEnable: () => !confirmationButton()!.disabled,
    toHaveBodyPadding: () => element.dataset.nobodypadding !== 'true',
  };
};

export default messageBoxFunctionalLayoutDriverFactory;
